/* tslint:disable */
/* eslint-disable */
/**
 * gtep-rfp-api API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RfpRequestDto
 */
export interface RfpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RfpRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RfpRequestDto
     */
    file: string;
}

export function RfpRequestDtoFromJSON(json: any): RfpRequestDto {
    return RfpRequestDtoFromJSONTyped(json, false);
}

export function RfpRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RfpRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'file': json['file'],
    };
}

export function RfpRequestDtoToJSON(value?: RfpRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'file': value.file,
    };
}

